{
  "version": 1,
  "asset_id": "7994ebae-f456-4fcd-96d1-d9ece4ee028b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7994ebae-f456-4fcd-96d1-d9ece4ee028b/hiatal-type-3-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7994ebae-f456-4fcd-96d1-d9ece4ee028b/hiatal-type-3-v3-1200.jpg",
  "original_filename": "hiatal-type-3-v3-1200.jpg",
  "size": 256249,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T22:48:12Z"
}
